import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Box } from "@mui/material";
import { MyNewsItemForm } from "my-news/forms";
import { MY_NEWS_CREATE_ITEM } from "my-news/graphql";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import {
  useOcCurrentUserState,
  useOcIsMobile,
  useOcProperty,
  useOcRoleFilters,
  useOcSnackbar,
} from "oc/hooks";

export const MyNewsNewPage = () => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();
  const history = useHistory();
  const { setOpenMessage } = useOcSnackbar();

  const { data: myNewsEnabled } = useOcProperty({
    resource: "myNews",
    key: "myNewsEnabled",
  });
  const myNewsMenuEnabled = myNewsEnabled === "false" ? false : true;

  const [createMyNewsItem] = useMutation(MY_NEWS_CREATE_ITEM, {
    onCompleted: (data) => {
      if (data) {
        const url = myNewsMenuEnabled ? "/" : "/my-news";
        history.push(url);
      }
      setOpenMessage({
        type: "success",
        message: t("OC_OPERATION_SUCCESSFUL"),
      });
    },
    onError: () => {
      setOpenMessage({
        type: "error",
        message: t("OC_OPERATION_UNSUCCESSFUL"),
      });
    },
  });

  const initialValues = {
    title: "",
    description: "",
    content: "",
    validFrom: null,
    validTo: null,
    priority: "normal",
    publish: false,
    isEdit: false,
  };

  const initialRoleFilter = {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  };

  let { contractCode: contract } = useOcCurrentUserState();
  const { roleFilters, handleAddFilter, handleRemoveFilter, resetRoleFilters } =
    useOcRoleFilters({
      contract,
      product: "MyNews",
      role: "editor",
      id: "MyNewsNewEmployeesFilter",
    });

  interface MyNewsFormValues {
    title: string;
    description: string;
    content: string;
    validFrom: Date | null;
    validTo: Date | null;
    priority: string;
    publish: boolean;
    isEdit: boolean;
    // Add other fields if needed
  }

  const handleSubmit = (values: MyNewsFormValues) => {
    const params = {
      ...values,
      roleFilters,
    };
    createMyNewsItem({
      variables: params,
    });
  };

  return (
    <OcPageTransition>
      <OcPageNameTitle title={t("MY_NEWS_NEW_ITEM")} goBack={false} />
      <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
        <MyNewsItemForm
          cardLabel={t("MY_NEWS_NEW_ITEM")}
          roleFilters={roleFilters}
          initialValues={initialValues}
          initialRoleFilter={initialRoleFilter}
          handleSubmit={handleSubmit}
          handleAddFilter={handleAddFilter}
          handleRemoveFilter={handleRemoveFilter}
          resetRoleFilters={resetRoleFilters}
          contract={contract}
          publishedAt={null}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyNewsNewPage;
